/**
 * Sub1 Template
 * @category testApp
 */
class AbilityrightcontentsTempl {
    /**
     * Sub1 Templ
     * @param  {Object} _d={}
     * @param  {String} _serverType=''
     */
    static getRightContentsTempl(_d={}, _serverType='') {
        let contentsTempl;
        if(_serverType === 'LIVE'){
            contentsTempl = AbilityrightcontentsTempl.getLiveTempl(_d);
        }
        else{
            contentsTempl = AbilityrightcontentsTempl.getNEOTempl(_d);
            // alert('server type error');
        }
        return `
        ${contentsTempl}    	
        `;
    }

    static getLiveTempl(_d){
        let liveValueArray;
        // 투사일 경우 분기(강체 속성 추가됨)
        if(_d.total.guardGauge > 0){
            liveValueArray =
                [
                    ['강체',_d.total.guardGauge,''],
                    ['생명력',_d.total.maxHp,''],
                    ['방어력',_d.total.defendPowerValue,''],
                    ['대인 방어력',_d.total.pcDefendPowerValue,''],
                    ['항마 방어력',_d.total.bossDefendPowerValue,''],
                    ['회피',_d.total.defendDodgeValue,''],
                    ['막기',_d.total.defendParryValue,''],
                    ['치명방어',_d.total.defendCriticalValue,''],
                    ['근성',_d.total.defendStiffDurationLevel,'단계'],
                    ['재생',_d.total.hpRegen,''],
                    ['회복',_d.total.healPowerRate,'%'],
                    ['상태이상방어력',_d.total.abnormalDefendPowerValue,''],
                    ['피해감소',_d.total.defendDamageModifyDiff,''],
                    ['봉마 내성','','','ability-contents-title'],
                    ['신귀의 보호',_d.benefit.raceType1DefendDamageModifyPercent,'%'],
                    ['진룡의 보호', _d.benefit.attributeType1DefendDamageModifyPercent,'%'],
                    ['금호의 보호', _d.benefit.attributeType2DefendDamageModifyPercent,'%']
                ];
        }
        else{
            liveValueArray =
                [
                    ['생명력',_d.total.maxHp,''],
                    ['방어력',_d.total.defendPowerValue,''],
                    ['대인 방어력',_d.total.pcDefendPowerValue,''],
                    ['항마 방어력',_d.total.bossDefendPowerValue,''],
                    ['회피',_d.total.defendDodgeValue,''],
                    ['막기',_d.total.defendParryValue,''],
                    ['치명방어',_d.total.defendCriticalValue,''],
                    ['근성',_d.total.defendStiffDurationLevel,'단계'],
                    ['재생',_d.total.hpRegen,''],
                    ['회복',_d.total.healPowerRate,'%'],
                    ['상태이상방어력',_d.total.abnormalDefendPowerValue,''],
                    ['피해감소',_d.total.defendDamageModifyDiff,''],
                    ['','',''],
                    ['봉마 내성','','','ability-contents-title'],
                    ['신귀의 보호',_d.benefit.raceType1DefendDamageModifyPercent,'%'],
                    ['진룡의 보호',_d.benefit.attributeType1DefendDamageModifyPercent,'%'],
                    ['금호의 보호',_d.benefit.attributeType2DefendDamageModifyPercent,'%']
                ];
        }
        let resultValueArray = AbilityrightcontentsTempl.intDot(liveValueArray);
        let AbilityContentsTableList = AbilityrightcontentsTempl.getAbilityContetnsTableList(resultValueArray);

        return `
        <ul class="ability-contetns-table">
            ${AbilityContentsTableList}
        </ul>
    	`;
    }

    static getNEOTempl(_d){
        let neoValueArray =
            [
                ['재생',_d.hpRegen,''],
                ['방어력',_d.defendPower,''],
                ['회피',_d.defendDodge,''],
                ['막기',_d.defendParry,''],
                ['치명 방어',_d.defendCritical,''],
                ['치명 피해 방어',_d.defendCriticalDamage,''],
                ['추가 피해 감소',_d.defendDamageModify,''],
                ['상태이상 내성',_d.defendAbnormalResistance,''],
                ['상태이상 방어',_d.abnormalDefendPower,''],
                ['회복력',_d.healPowerPercent,'%'],
                ['광역 방어력',_d.aoedefendPower,'']
            ];
        let resultValueArray = AbilityrightcontentsTempl.intDot(neoValueArray);
        let AbilityContentsTableList = AbilityrightcontentsTempl.getAbilityContetnsTableList(resultValueArray);

        return `
        <ul class="ability-contetns-table">
            ${AbilityContentsTableList}
        </ul>
    	`;
    }

    // int 천단위 이상 dot 추가
    static intDot(_valueArray){
        let resultValueArray;
        for(let i=0;i<_valueArray.length;i++){
            for(let j=1;j<_valueArray[i].length;j++){
                if(_valueArray[i][j]>0) _valueArray[i][j] = _valueArray[i][j].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                if(_valueArray[i][1] == undefined) _valueArray[i][j] = '-';
            }
        }
        resultValueArray = _valueArray;

        return resultValueArray;
    }

    // 리스트 능력치 아이템(li) 템플릿
    static getAbilityContetnsTableList(_valueArray){
        let AbilityContentsTableList = ``;
        for(let i=0;i<_valueArray.length;i++){
            if(_valueArray[i][3] == 'ability-contents-title'){
              AbilityContentsTableList += `
                <li class="${_valueArray[i][3]}">                  
                  <div>${_valueArray[i][0]}</div>
                </li>
              `;
            }else{
              AbilityContentsTableList += `
              <li ${_valueArray[i][3] ? `class="${_valueArray[i][3]}}"`:``}>
                  <div class="ability-contents-th"><em>${_valueArray[i][0]}</em></div>
                  <div class="ability-contents-td"><span>${_valueArray[i][1]}${_valueArray[i][2]}</span></div>
              </li>
            `;
            }

        }

        return AbilityContentsTableList;
    }
} // end of class

export default AbilityrightcontentsTempl;